import { useState } from 'react';
import { FormatColorText, Check, ExpandMore } from '@mui/icons-material';
import { Box, Button, Popover } from '@mui/material';
import { useActive, useCommands } from '@remirror/react';

import { themeV5 } from '../../../AiThemeProvider/AiThemeProvider';

const ColorButtonMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const { setTextColor } = useCommands();
  const { textColor } = useActive();
  const isDisabled = !setTextColor.enabled();

  const selectedColor = colors.flat().find(color => textColor({ color })) ?? null;

  return (
    <>
      <Button
        id="color-menu-button"
        size="small"
        endIcon={<ExpandMore />}
        disabled={isDisabled}
        onClick={e => setAnchorEl(e.currentTarget)}
      >
        <FormatColorText />
      </Button>
      <Popover
        id="color-menu"
        aria-labelledby="color-menu-button"
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        keepMounted
      >
        <Box
          sx={{
            px: 1,
            py: 0.5,
            gap: 0.5,
            display: 'grid',
            gridAutoFlow: 'column',
            gridTemplateRows: 'repeat(3, 1fr)'
          }}
        >
          {colors.flat().map(color => (
            <ColorBox key={color} color={color} selectedColor={selectedColor} onClose={() => setAnchorEl(null)} />
          ))}
        </Box>
      </Popover>
    </>
  );
};

const ColorBox = ({ color, selectedColor, onClose }) => {
  const { focus, setTextColor, removeTextColor } = useCommands();
  const { textColor } = useActive();
  const isPrimary = color === primary['main'];

  const handleClick = () => {
    onClose();

    if (isPrimary) {
      removeTextColor();
    } else {
      setTextColor(color);
    }

    focus();
  };

  return (
    <Box
      role="button"
      bgcolor={color}
      color={getContrastText(color)}
      width={26}
      height={26}
      borderRadius={0.5}
      onClick={handleClick}
    >
      {textColor({ color }) || (isPrimary && !selectedColor && <Check color="inherit" />)}
    </Box>
  );
};

const { primary, info, success, warning, error, secondary, getContrastText } = themeV5.palette;

const colors = [
  [primary['main'], primary['light'], primary['contrastText']],
  [info['darkText'], info['main'], info['lightBg']],
  [success['darkText'], success['main'], success['lightBg']],
  [warning['darkText'], warning['main'], warning['lightBg']],
  [error['darkText'], error['main'], error['lightBg']],
  [secondary['darkText'], secondary['main'], secondary['light']]
];

export default ColorButtonMenu;
